import { Button } from 'antd';
import React from 'react'

export default function AppraisalButtonRendering(props: any) {
  const { handelSaveRevise, newCtcError } = props;
  return (
    // <div data-testid='button-id'>
    //   {touched && (
    // <div className='flex justify-center mr-5 salary_add-btn'>
    //   {!incrementEligible ? (
    //     <button className='addButton' onClick={() => handelSaveRevise()}>
    //       Save
    //     </button>) : (
    //     <button className='addButton ' onClick={() => handelChangeSalary()}>
    //       Next
    //     </button>
    //   )}
    // </div>        
    //   )}
    // </div>
    <div className='flex justify-center mr-5 salary_add-btn space-x-2'>
      {/* {!incrementEligible ? ( */}

      <Button disabled={newCtcError !== ''} className='addButton' onClick={() => handelSaveRevise('Draft')}>
        Draft
      </Button>
      <Button disabled={newCtcError !== ''} className='addButton' onClick={() => handelSaveRevise('Save')}>
        Submit
      </Button>

      {/* ) : (
        <button className='addButton ' onClick={() => handelChangeSalary()}>
          Next
        </button>
      )} */}
    </div>
  )
}
